jQuery('img').on('dragstart', function(event) { event.preventDefault(); });

jQuery(function($) {
    $('.hamburger-nav').on('click', function() {
         $('header').toggleClass('mobile-menu-open');
         $("body").toggleClass("hide-scroll-menu");
         $("main").toggleClass("div-go-lft-menu");
    });
    $(".sunology_product_drop").click(function () {
        $(".mobile-submenu").toggleClass("open-submenu");
        $(".rotate-0").toggleClass("reverse");
    });  
});

jQuery(function ($) {

    $('#homepic_carousel').owlCarousel({
        loop: true,
        autoplay: false,
        autoplayTimeout: 4000,
        margin: 20,
        nav: true,
        navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none"><path d="M20 24.5L12 16.5L20 8.5" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none"><path d="M12 24.5L20 16.5L12 8.5" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>'],
        dots: false,
        items: 1,
        animateOut: "fadeOut",
        animateIn: "fadeIn",
        touchDrag: true,
        mouseDrag: true,
        smartSpeed: 1000,
        responsive: {
            0: {
                items: 1,
            },
            767: {
                items: 1,
            },
            991: {
                items: 1,
            },
            1199: {
                items: 1,
            },
            1360: {
                items: 1,
            }
        }
    });


    $('#energy_toolbox_carousel').owlCarousel({
        loop: true,
        autoplay: false,
        autoplayTimeout: 4000,
        margin: 20,
        nav: false,
        navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none"><path d="M20 24.5L12 16.5L20 8.5" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none"><path d="M12 24.5L20 16.5L12 8.5" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>'],
        dots: true,
        items: 1,
        animateOut: "fadeOut",
        animateIn: "fadeIn",
        touchDrag: true,
        mouseDrag: true,
        smartSpeed: 1000,
        responsive: {
            0: {
                items: 1.5,
                nav: false,
                dots: true,
            },
            767: {
                items: 2,
                nav: false,
                dots: true,
            },
            991: {
                items: 2.5,
                nav: false,
                dots: true,
            }
        }
    });

    /*============================================= Home tab js ===============================================*/
    
    $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 4000,
        asNavFor: '.slider-nav',
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    draggable: true,
                    swipe:true,
                    swipeToSlide:true,
                    loop: false,
                }
            },
        ]
    });

    $('.slider-nav').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        dots: false,
        arrows: false,
        variableWidth: true,
        loop: false,
        infinite: false,
        centerMode: true,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 650,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                }
            },
            {
                breakpoint: 520,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                }
            },
        ]
    });

    /*============================================= Home tab js ===============================================*/

    //===========tab js================== 

    jQuery(function ($) {
        $(".tab-slider--body").hide();
        $(".tab-slider--body:first").show();

        $(".tab-slider--nav li").click(function () {
            $(".tab-slider--body").hide();
            var activeTab = $(this).attr("rel");
            $("#" + activeTab).fadeIn();
            if ($(this).attr("rel") == "tab2") {
                $('.tab-slider--tabs').addClass('slide');
            } else {
                $('.tab-slider--tabs').removeClass('slide');
            }
            $(".tab-slider--nav li").removeClass("active");
            $(this).addClass("active");
        });

        //===========tab js================== 


        $('#dropup_btn').click(function () {
            $(this).toggleClass("rotatearrow");
        });
    });

});


//===========dropup js================== 
function openDropdown(event, dropdownID) {
    let element = event.target;
    while (element.nodeName !== "BUTTON") {
        element = element.parentNode;
    }
    var popper = Popper.createPopper(element, document.getElementById(dropdownID), {
        placement: 'top-end'
    });
    document.getElementById(dropdownID).classList.toggle("hidden");
    document.getElementById(dropdownID).classList.toggle("block");
}
//===========dropup js================== 

//===========rangeslider script==================

var sheet = document.createElement('style'),  
  $rangeInput = jQuery('.younited-range #customRange1'),
  prefs = ['webkit-slider-runnable-track', 'moz-range-track', 'ms-track'];

document.body.appendChild(sheet);
function getTrackStyle(el) {
  var val = mapBetween(el.value, 0, 100, el.min, el.max),
      style = '';
  
  // Change background gradient
  for (var i = 0; i < prefs.length; i++) {
    style += '.younited-range:not(.alma-range) {background: linear-gradient(to right, #EDFF00 0%, #EDFF00 ' + val + '%, #fff ' + val + '%, #fff 100%)}';
    style += '.younited-range:not(.alma-range) input::-' + prefs[i] + '{background: linear-gradient(to right, #EDFF00 0%, #EDFF00 ' + val + '%, #b2b2b2 ' + val + '%, #b2b2b2 100%)}';
  }
  return style;
}

function mapBetween(currentNum, minAllowed, maxAllowed, min, max) {
  return (maxAllowed - minAllowed) * (currentNum- min) / (max - min) + minAllowed;
}

$rangeInput.on('input', function () {
  sheet.textContent = getTrackStyle(this);
});

//===========rangeslider script==================



/*============================================= Progress Bar Slider js ===============================================*/

jQuery(function ($) {
    var $slider = $(".solarslider");
    var $progressBar = $(".solarprogress");
    var $progressBarLabel = $(".slider__label");

    $slider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        var calc = (nextSlide / (slick.slideCount - 1)) * 100;

        $progressBar.css("background-size", calc + "% 100%").attr("aria-valuenow", calc);

        $progressBarLabel.text(calc + "% completed");
    });

    $slider.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        speed: 1500,
        autoplay: false,
        dots: false,
        arrows: true,
        autoplaySpeed: 3000,
        infinite: true,
        centerMode: true,
        centerPadding: '38px',
        swipeToSlide: true,
        waitForAnimate: false,
        prevArrow: '<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none"><path d="M20 24.5L12 16.5L20 8.5" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
        nextArrow: '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none"><path d="M12 24.5L20 16.5L12 8.5" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    centerPadding: '42px',
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    centerPadding: '0',
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: false,
                    centerPadding: '0',
                },
            },

            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1.8,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: false,
                    centerPadding: '0',
                    
                },
            },

            {
                breakpoint: 414,
                settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: false,
                },
            },

            {
                breakpoint: 340,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: false,
                },
            },
        ],
    });
});

/*============================================= Progress Bar Slider js ===============================================*/

//===========sudipta==================

jQuery(function ($) {
    $('#big-mdl-sec').click(function () {
        $('#big-mdl-sec').addClass('active-menu');
    });
    $('.btn-close-svg').click(function () {
        $('#big-mdl-sec').removeClass('active-menu');
    });
});


jQuery(function ($) {
    $("#open-one").click(function () {
        $("#modalOverlay").show().addClass("modal-open");
    });

    $("#close").click(function () {
        var modal = $("#modalOverlay");
        modal.removeClass("modal-open");
        setTimeout(function () {
            modal.hide();
        }, 200);
    });
});

jQuery(function ($) {
    $("#open-two").click(function () {
        $("#modalOverlay-two").show().addClass("modal-open");
    });

    $("#close-two").click(function () {
        var modal = $("#modalOverlay-two");
        modal.removeClass("modal-open");
        setTimeout(function () {
            modal.hide();
        }, 200);
    });
});

jQuery(function ($) {
    $("#open-three").click(function () {
        $("#modalOverlay-three").show().addClass("modal-open");
        $('.crisp-client').hide();
    });

    $("#close-three").click(function () {
        var modal = $("#modalOverlay-three");
        $('.crisp-client').show();
        modal.removeClass("modal-open");
        setTimeout(function () {
            modal.hide();
        }, 200);
    });
});

jQuery(function ($) {
    $("#open-custome-slide").click(function () {
        $("#finance-sidescr-popup").show().addClass("modal-open");
        $('.crisp-client').hide();
    });

    $("#back-pre-financ").click(function () {
        var modal = $("#finance-sidescr-popup");
        $('.crisp-client').show();
        modal.removeClass("modal-open");
        setTimeout(function () {
            modal.hide();
        }, 200);
    });
});

jQuery(function ($) {
    $("#big-modal-close").click(function () {
        $("body").removeClass("hide-scroll");
        $("body").removeClass("modal-reviews-visible");
        $(".shopify-section-group-v4-header-group[id$=\"_header\"]").removeClass("!-tw-translate-y-banner");
    });
});


jQuery(function ($) {
    $("#big-modal-box-mobo").click(function () {
        $("#big-modal-box-mobo-sec").show().addClass("modal-open");
        // Hide Spec modal
        var specmodal = $(".spece-modal-box");
        specmodal.removeClass("modal-open");
        specmodal.hide();
        jQuery("body").addClass("hide-scroll");
        jQuery("body").addClass("modal-reviews-visible");
        jQuery(".shopify-section-group-v4-header-group[id$=\"_header\"]").addClass("!-tw-translate-y-banner");
        jQuery("#mobo-ftr-btn").click();
    });

    $("#big-modal-close-two").click(function () {
        var modal = $("#big-modal-box-mobo-sec");
        modal.removeClass("modal-open");
        if(jQuery("header").hasClass("add-overlayy")){
          jQuery("header").removeClass("add-overlayy");
        }
        if(jQuery("header").hasClass("scroll-offf")){
          jQuery("body").toggleClass("scroll-offf");
        }

        jQuery("body").removeClass("hide-scroll");
        jQuery("body").removeClass("modal-reviews-visible");
        jQuery(".shopify-section-group-v4-header-group[id$=\"_header\"]").removeClass("!-tw-translate-y-banner");

        setTimeout(function () {
            modal.hide();
        }, 200);
    });
});

jQuery(function ($) {
    $(".pp-mdl-one").owlCarousel({
        loop: true,
        margin: 30,
        nav: false,
        dots: false,
        responsive: {
            0: {
                items: 1.3,
                autoplay: false,
                autoplayTimeout: 3000,
                autoplayHoverPause: false,
                margin: 16,
            },
            575: {
                items: 2.3,
                autoplay: false,
                autoplayTimeout: 3000,
                autoplayHoverPause: false,
                margin: 16,
            },
            767: {
                items: 3,
                loop: false,
                autoplay: false,
                autoplayTimeout: 3000,
                autoplayHoverPause: false,
                margin: 16,
            },
            1199: {
                items: 3,
                loop: false,
                autoplay: false,
                autoplayTimeout: 3000,
                autoplayHoverPause: false,
            },
        },
    });
    
    $(".pp-includ").owlCarousel({
        loop: true,
        margin: 20,
        nav: true,
        autoplay: false,
        navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none"><path d="M20 24.5L12 16.5L20 8.5" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none"><path d="M12 24.5L20 16.5L12 8.5" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>'],
        dots: false,
        autoWidth: false,
        responsive: {
            0: {
                items: 1.1,
                nav: false,
                margin: 16,
                autoWidth: false,
            },
            480: {
                items: 1.1,
                nav: false,
                margin: 16,
                autoWidth: false,
            },
            639: {
                items: 1.1,
                nav: false,
                margin: 16,
                autoWidth: false,
            },
            991: {
                items: 3,
                autoWidth: false,
            },
            1199: {
                items: 4,
                autoWidth: false,
            },
        },
    });
    
    $(".pp-open-accs").owlCarousel({
        loop: true,
        center: true,
        margin: 30,
        autoplay: false,
        nav: true,
        navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none"><path d="M20 24.5L12 16.5L20 8.5" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none"><path d="M12 24.5L20 16.5L12 8.5" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>'],
        dots: false,
        responsive: {
            0: {
                items: 1.2,
                nav: false,
                center: false,
                margin: 16,
            },
            639: {
                items: 2,
                nav: false,
                center: false,
                margin: 16,
            },
            767: {
                items: 2.2,
                nav: false,
                margin: 16,
            },
            1000: {
                items: 3,
            },
        },
    });

    $("#pp-change-time").owlCarousel({
        loop: true,
        margin: 16,
        nav: true,
        dots: false,
        navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none"><path d="M20 24.5L12 16.5L20 8.5" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none"><path d="M12 24.5L20 16.5L12 8.5" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>'],
        responsive: {
            0: {
                items: 1.2,
                nav: false,
            },
            639: {
                items: 2,
                nav: false,
            },
            767: {
                items: 3,
                nav: false,
                autoWidth: true,
            },
            1199: {
                items: 5,
                autoWidth: true,
            },
        },
    });
    
    $("#pp-mountion-support").owlCarousel({
        loop: false,
        margin: 30,
        nav: false,
        dots: false,
        autoplay: false,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                loop: true,
                items: 1.8,
                autoplay: false,
                autoplayTimeout: 3000,
                autoplayHoverPause: true,
                margin: 20,
            },
            575: {
                loop: true,
                items: 2.5,
                autoplay: false,
                autoplayTimeout: 3000,
                autoplayHoverPause: false,
                margin: 20,
            },
            767: {
                loop: false,
                items: 3.5,
                autoplay: false,
                autoplayTimeout: 3000,
                autoplayHoverPause: false,
                margin: 20,
            },
            1080: {
                loop: false,
                items: 5,
                autoplay: false,
                autoplayTimeout: 3000,
                autoplayHoverPause: false,
            },
        },
    });
    
    $(".pp-stamp-sec").owlCarousel({
        loop: true,
        margin: 30,
        nav: false,
        dots: false,
        responsive: {
            0: {
                items: 1.2,
            },
            600: {
                items: 2,
            },
            1000: {
                items: 3,
            },
        },
    });
});

jQuery(function ($) {
    $("#mobo-ftr-btn").click(function () {
        $(".pop-menu").toggleClass("open-menu");
        $(".action-sec").toggleClass("full-btn");
        $(".logo-two").toggleClass("hide-logo");

        if(!$(".v4-bottom-bar")) {
            $("header").toggleClass("add-overlay");
            $("body").toggleClass("scroll-off");
        }
    });
});


// video on scroll play
jQuery(function ($) {

    var $video = $('.video');
    var $window = $(window);

    if($video.length === 0) return;

    $window.scroll(function () {

        var $topOfVideo = $video.offset().top;
        var $bottomOfVideo = $video.offset().top + $video.outerHeight();

        var $topOfScreen = $window.scrollTop();
        var $bottomOfScreen = $window.scrollTop() + $window.innerHeight();

        if (($bottomOfScreen > $bottomOfVideo) && ($topOfScreen < $topOfVideo)) {
            $video[0].play();
        } else {
            $video[0].pause();
        }

    });
});



// big slider animaton

jQuery(function ($) {
    //----- OPEN
    $("body").on("click", "[data-popup-open]",function (e) {
        var targeted_popup_class = jQuery(this).attr("data-popup-open");
        setTimeout(function () {
            $('[data-popup="' + targeted_popup_class + '"]').addClass("popup-open");
            $('.crisp-client').hide();
            $('body').addClass('!tw-overflow-hidden');
            $(".shopify-section-group-v4-header-group[id$=\"_header\"]").addClass("!-tw-top-banner");
            $('[data-popup="' + targeted_popup_class + '"]').fadeIn(200);
        }, 250);

        e.preventDefault();
        start_slider(targeted_popup_class);

    });

    //----- CLOSE
    $("body").on("click", "[data-popup-close]",function (e) {
        var targeted_popup_class = jQuery(this).attr("data-popup-close");
        $('[data-popup="' + targeted_popup_class + '"]').removeClass("popup-open");
        $('.crisp-client').show();
        $('body').removeClass('!tw-overflow-hidden');
        $(".shopify-section-group-v4-header-group[id$=\"_header\"]").removeClass("!-tw-top-banner");
        const track = document.querySelector("." + targeted_popup_class + ".h-track");
        track.setAttribute("data-scroll", 0);
        e.preventDefault();
    });

    $(".side-row").click(function () {
        $("main").addClass("div-go-lft");
    });

    $(".btn-close").click(function () {
        $("main").removeClass("div-go-lft");
    });
});

function start_slider(targeted_popup_class) {
    const track = document.querySelector("." + targeted_popup_class + ".h-track");
    if (track) {
        track.classList.add("invisible-scrollbar");
        const trackContainer = track.querySelector(".h-content-container");

        let registeredScroll = false;
        let outerWidth = track.offsetWidth;
        let innerWidth = trackContainer.scrollWidth;

        const updatePct = () => {
            const pct = (track.scrollLeft / (innerWidth - outerWidth)) * 100;

            track.dataset.scrollPercent = pct;
           /*  document.documentElement.style.setProperty("--scroll-pct", `${track.dataset.scrollPercent}%`); */
           jQuery('.progress-bar-state').css({ "width": pct + "%" });
        };
        updatePct();

        window.addEventListener("resize", (e) => {
            outerWidth = track.offsetWidth;
            innerWidth = trackContainer.scrollWidth;
            updatePct();
        });

        track.addEventListener("scroll", (evt) => {
            if (!registeredScroll) {
                track.setAttribute("data-scroll", track.scrollLeft + evt.deltaY + evt.deltaX);
            }
        });

        track.addEventListener("wheel", (evt) => {
            registeredScroll = true;
            evt.preventDefault();
            const tpMultiplier = evt.deltaY % 1 === 0 ? 5 : 1;
            track.setAttribute("data-scroll", track.scrollLeft + evt.deltaY * tpMultiplier + evt.deltaX * tpMultiplier);
            var x = track.scrollLeft + evt.deltaY * tpMultiplier + evt.deltaX * tpMultiplier;
            if (x >= 300) {
                jQuery(".drag-div").addClass('drag-div-hide')
            } else {
                if (jQuery(".drag-div").hasClass('drag-div-hide')) {
                    jQuery(".drag-div").removeClass('drag-div-hide');
                }
            }
        });
       

        let pos = { top: 0, left: 0, x: 0, y: 0 };

        window.addEventListener("keydown", (e) => {
            if (e.key === "ArrowUp" || e.key === "ArrowLeft") {
                registeredScroll = true;
                track.setAttribute("data-scroll", track.scrollLeft - 100);
            } else if (e.key === "ArrowDown" || e.key === "ArrowRight") {
                registeredScroll = true;
                track.setAttribute("data-scroll", track.scrollLeft + 100);
            }
        });

        const mouseDownHandler = (e) => {
            registeredScroll = true;

            track.style.cursor = "grabbing";
            track.style.userSelect = "none";

            pos = {
                left: track.scrollLeft,
                x: e.clientX ?? e.touches?.[0]?.clientX + e.touches?.[0]?.clientY ?? 0,
            };

            document.addEventListener("mousemove", mouseMoveHandler);
            document.addEventListener("mouseup", mouseUpHandler);
        };

        const mouseMoveHandler = (e) => {
            registeredScroll = true;

            const cx = e.clientX ?? e.touches?.[0]?.clientX + e.touches?.[0]?.clientY ?? 0;
            const dx = cx - pos.x;
            track.setAttribute("data-scroll", pos.left - dx);
        };

        const mouseUpHandler = () => {
            document.removeEventListener("mousemove", mouseMoveHandler);
            document.removeEventListener("mouseup", mouseUpHandler);

            track.style.cursor = "grab";
            track.style.removeProperty("user-select");
        };

        track.addEventListener("mousedown", mouseDownHandler);

        const update = () => {
            if (registeredScroll) {
                const toX = parseFloat(track.getAttribute("data-scroll")) ?? 0;
                const dx = toX - track.scrollLeft;

                if (dx > 1 || dx < -1) {
                    track.scrollLeft += dx * 0.1;
                } else {
                    track.scrollLeft = toX;
                    registeredScroll = false;
                }
            }
            updatePct();
            requestAnimationFrame(update);
        };

        requestAnimationFrame(update);
    }
}

// ==================all modal click add class

jQuery(".side-row").click(function () {
    jQuery("body").addClass("hide-scroll");
});
jQuery(".btn-close").click(function () {
    jQuery("body").removeClass("hide-scroll");
});

jQuery(".btn-close").click(function () {
    jQuery("body").removeClass("hide-scroll");
});

jQuery(".neonglow").click(function () {
    jQuery("body").addClass("hide-scroll");
});
jQuery(".btn-close").click(function () {
    jQuery("body").removeClass("hide-scroll");
});
jQuery(".learnarw").click(function () {
    jQuery("body").addClass("hide-scroll");
});


new WOW({
    mobile: false,
    callback: function(e) {
        e.addEventListener('animationstart', () => {
            e.classList.add('animation-started')
        })
        e.addEventListener('animationend', () => {
            e.classList.add('animation-finish')
        })
    }
}).init();

function handleAnchorScrollTo() {
    // Check if a hash is present in the URL
    if (window.location.hash) {
      // Get the target element by its ID (without the '#')
      var targetId = window.location.hash.substring(1);
      var targetElement = document.getElementById(targetId);
  
      // Check if the target element exists
      if (targetElement) {
        setTimeout(function() {
            // Calculate the target position
            var targetPosition = targetElement.offsetTop;
    
            // Scroll to the target element
            window.scrollTo({
                top: targetPosition,
                behavior: "auto" // You can use "auto" for instant scrolling
            });
        }, 2000);
      }
    }
}

// Wait for the document to be fully loaded
document.addEventListener('DOMContentLoaded', () => {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(handleAnchorScrollTo);
  } else {
    handleAnchorScrollTo();
  }
})